import { Component, OnInit, OnDestroy, Inject, Optional, Injectable, ChangeDetectorRef } from '@angular/core'
import { GSBaseControl } from './gs.base.control';
import { FormSimpleListProperty } from '../entity/form/formSimpleList.property';
import { Item } from '../entity/entities';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
} from '@angular/forms';

@Component({
  selector: 'gs-simple-list',
  templateUrl: './gs.simpleList.control.html'
})
@Injectable()
export class GSSimpleListControl extends GSBaseControl implements OnInit, OnDestroy {
  //#region -------Properties


  showList = false;
  form: FormGroup<{ items }>;

  get items() {
    return this.form.get('items') as FormArray;
  }

  addText = 'Click to add';
  //#endregion

  //#region -------Constructor
  //#endregion
  //#region -------NG Eents
  ngOnInit() : void {
    const items = this.value?.split(';') || [];
    this.form = this.fb.group({
      items: this.fb.array(
        items.map((email) =>
          this.fb.control(email)
        )
      ),
    });
  }

  ngOnDestroy() {
  }
  //#endregion

  //#region -------Constructor
  constructor(@Optional() prop: FormSimpleListProperty, @Optional() item: Item, private changeDr: ChangeDetectorRef, private fb: FormBuilder) {
    super(changeDr);
        this.property = prop;
        this.item = item;
    }
  //#endregion

  //#region -------UI Events
  click(e) {
      this.onClick.emit(e);
      this.property.click.emit({ propertyName: this.name, event: e });    
  }

  removeItem(i) {
    this.items.removeAt(i);
  }

  addItem() {
     this.items.push(this.fb.control(''));
  }

  hide() {
    const items = this.items.value.filter((x) => x).join(';');
    let previousValue = this.item.data[this.property.name];    
    this.item.data[this.property.name] = items;

    this.onChange.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: items, item: this.item, property: this.property });   
    this.property.changed.emit({
      propertyName: this.property.name,
      newValue: items,
      item: this.item,
      property: this.property,
    });


    

  }

  //#endregion

  //#region -------Private
  //#endregion
}
